import axios from 'axios';
import { RegisterData } from '../../shared/type/register-data';
import { ResponseError } from '../error';

function preparePhone(phone: string): string {
  return phone.replace(/\(|\)|\-|\s+/gis, '');
}

export const regNewUser = async (locale: string, data: RegisterData) => {
  data.phone = preparePhone(data.phone);
  delete data.termsAgreed;

  const resp = await axios.post(`/registration`, JSON.stringify(data), {
    headers: {
      'Content-Type': 'application/json',
      'Accept-Language': locale,
    },
  });

  if (resp.status !== 200) {
    throw new ResponseError('', resp.data);
  }

  return true;
};

export async function completeRegister(phone: string, code: string, locale: string) {
  phone = preparePhone(phone);
  const resp = await axios.post(
    '/api/v1/complete-registration',
    {
      phone,
      code,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': locale,
      },
    },
  );

  if (resp.status !== 200) {
    throw new ResponseError('', resp.data);
  }

  return true;
}
